import { AppConfig } from '../../../../app.config';
import { HelpersService } from '../../../../services/helpers.service';
import { ProductsService } from '../../../../services/products.service';
import { ProcurementService } from '../../../../services/procurement.service';
import { CountriesService } from '../../../../services/countries.service';
import { Component, OnInit, Input } from '@angular/core';
import {
  Validators,
  FormControl,
  FormGroup,
  FormBuilder,
} from '@angular/forms';

@Component({
  selector: 'app-procurement',
  templateUrl: './procurement.component.html',
  styleUrls: ['./procurement.component.scss'],
})
export class ProcurementComponent implements OnInit {
  public searchForm: FormGroup;
  public countries = []; //this.appConfig.getSupportedCountries();
  public Radius: Number = 50;
  public loading: boolean = false;
  public searchComplete: boolean = false;
  public searchResults: any = [];
  public brands = [
    { label: 'Specialized', value: 'Specialized' },
    { label: 'Giant', value: 'Giant' },
    { label: 'ABC / Avalanche', value: 'ABC / Avalanche' },
    { label: 'GT', value: 'GT' },
    { label: 'Merida', value: 'Merida' },
    { label: 'PYGA', value: 'PYGA' },
    { label: 'Silverback', value: 'Silverback' },
    { label: 'Mongoose', value: 'Mongoose' },
    { label: 'Titan', value: 'Titan' },
    { label: 'Yeti', value: 'Yeti' },
    { label: 'Cannondale', value: 'Cannondale' },
    { label: 'Garmin', value: 'Garmin' },
    { label: 'Swift', value: 'Swift' },
  ].sort(function (a, b) {
    if (a.label < b.label) return -1;
    if (a.label > b.label) return 1;
    return 0;
  });

  public bikeResults: any = [];

  constructor(
    public fb: FormBuilder,
    public appConfig: AppConfig,
    public helpersService: HelpersService,
    public productsService: ProductsService,
    private countriesService: CountriesService,
    public procurementService: ProcurementService,
  ) {}

  ngOnInit() {
    this.countriesService.getAllCountries().subscribe((countries) => {
      this.countries = countries.map((x) => {
        return { ...x, label: x.country, value: x.code };
      });
    });

    this.searchForm = this.fb.group({
      Country: new FormControl('', [Validators.required]),
      Area: new FormControl('', [Validators.required]),
      Brand: new FormControl('', [Validators.required]),
      Search: new FormControl('', [Validators.required]),
      ShowStockRecordsOnly: new FormControl(false),
    });

    this.searchForm.reset({
      Country: { value: 'ZA', disabled: true },
      Area: { value: 'Stellenbosch', disabled: true },
      Brand: this.brands
        .filter((x) => {
          return x.value === 'Specialized';
        })
        .pop().value,
      ShowStockRecordsOnly: false,
    });
  }

  searchBikes(event) {
    var data = {
      CountryCode: this.searchForm.controls['Country'].value,
      Area: this.searchForm.controls['Area'].value,
      Radius: this.Radius,
      Brand: this.searchForm.controls['Brand'].value,
      Search: this.searchForm.controls['Search'].value,
    };
    this.procurementService.getAutoComplete(data).subscribe((results) => {
      this.bikeResults = results.map((item) => {
        return item.Name;
      });
    });
  }

  bikeSelected(event) {
    this.searchForm.controls['Search'].setValue(event);
  }

  searchStores() {
    this.loading = true;
    this.searchComplete = false;

    var data = {
      CountryCode: this.searchForm.controls['Country'].value,
      Area: this.searchForm.controls['Area'].value,
      Radius: this.Radius,
      Brand: this.searchForm.controls['Brand'].value,
      Search: this.searchForm.controls['Search'].value,
      ShowStockRecordsOnly:
        this.searchForm.controls['ShowStockRecordsOnly'].value,
    };
    this.procurementService.searchPartnersForProduct(data).subscribe(
      (results) => {
        this.loading = false;
        this.searchComplete = true;
        this.searchResults = results;
      },
      (err) => {
        this.loading = false;
        this.searchComplete = true;
        this.searchResults = [];
      },
    );
  }
}
